import {
	doRequest
} from "./http";

let authApiHttp = {
	// 用户登录
	user$wx_login: ({
		js_code,
		captcha
	}) => {
		return doRequest("POST", {
			url: "user/wx_login",
			body: {
				js_code,
				captcha
			},
		});
	},
	// 手机号登录
	user$mobilelogin: ({
		mobile,
		captcha
	}) => {
		return doRequest("POST", {
			url: "user/mobilelogin",
			body: {
				mobile,
				captcha
			},
		});
	},
	// 发送验证码（event:register=注册,mobilelogin=手机号登录，changemobile=更换手机号,resetpwd=更换密码,）
	sms$send: ({
		mobile,
		event
	}) => {
		return doRequest("POST", {
			url: "sms/send",
			body: {
				mobile,
				event
			},
		});
	},
	// 微信二维码登录
	user$wechatCallback: ({
		code,
		state
	}) => {
		return doRequest("POST", {
			url: "user/wechatCallback",
			body: {
				code,
				state
			},
		});
	},
	// 获取我的信息
	user$getUserInfo: () => {
		return doRequest("GET", {
			url: "user/getUserInfo",
		});
	},
	// 修改个人信息
	user$profile: ({
		user_id,
		username,
		avatar,
		mobile,
		nickname,
		student_class,
		gender,
		birthday,
	}) => {
		return doRequest("POST", {
			url: "user/profile",
			body: {
				user_id,
				username,
				avatar,
				mobile,
				nickname,
				student_class,
				gender,
				birthday,
			},
		});
	},

};

export default authApiHttp;